module.exports = __webpack_public_path__ + "img/manifesto_of_the_moletariate.eac7a3da.png";